import { Injectable, NgZone, DOCUMENT, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptInjectorService {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly zone = inject(NgZone);

  load(id: string, src: string): Promise<void> {
    const existingScriptElement = this.document.getElementById(id);

    if (existingScriptElement) {
      console.warn(`Script with id '${id}' is already loaded.`);

      return Promise.resolve();
    }

    const scriptElement: HTMLScriptElement =
      this.document.createElement('script');

    scriptElement.id = id;
    scriptElement.src = src;
    scriptElement.async = false;

    const promise = new Promise<void>((resolve, reject) => {
      scriptElement.addEventListener(
        'load',
        () => {
          setTimeout(resolve, 10);
        },
        { once: true }
      );

      scriptElement.addEventListener(
        'error',
        (err) => {
          reject(err);
        },
        { once: true }
      );
    });

    this.zone.runOutsideAngular(() => {
      this.document.head.appendChild(scriptElement);
    });

    return promise;
  }
}
